import { createReducer } from '@reduxjs/toolkit';

import {
  type AutocompleteResponsePayload,
  clearAutocompleteQuery,
  setAutocompleteResponse,
} from 'Core/actions/autocomplete';
import { fromPayload } from 'Core/reducers/common';

export const defaultAutocompleteResponseState: AutocompleteResponsePayload = {
  items: null,
  query: '',
  totalHits: 0,
};

export default createReducer(defaultAutocompleteResponseState, (builder) =>
  builder
    .addCase(clearAutocompleteQuery, () => defaultAutocompleteResponseState)
    .addCase(setAutocompleteResponse, fromPayload),
);
